import React, { useEffect } from "react"
import clsx from "clsx"
import { FormControl, InputLabel, TextField } from "@mui/material"
import PrintIcon from "@mui/icons-material/Print"
import BackspaceIcon from "@mui/icons-material/Backspace"


const NumericKeypad = ({ classes, onPrint, onChange, value, printDisabled = false }) => {
  const [inputValue, setInputValue] = React.useState(value)
  const textareaRef = React.useRef(null)

  const handleInputChange = (event) => {
    const value = event.target ? event.target.value : event
    if (/^\d*$/.test(value)) {
      setInputValue(value.replace(/^0+/, ""))
      onChange && onChange(value.replace(/^0+/, ""))
    }
  }

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus()
    }
  }, [textareaRef.current])

  const handleClickButton = (key) => {
    if (key === "p") {
      if (!printDisabled) onPrint && onPrint(inputValue)
    } else {
      const textarea = textareaRef.current
      if (!textarea) return
      const start = textarea.selectionStart
      const end = textarea.selectionEnd
      let newPosition = start + 1
      if (key === "b") {
        handleInputChange(inputValue.slice(0, start - 1) + inputValue.slice(end))
        newPosition = start - 1
      } else {
        const value = "" + inputValue
        const newValue = value.slice(0, start) + key + value.slice(end)
        handleInputChange(newValue)
      }

      setTimeout(() => {
        textarea.focus()
        textarea.setSelectionRange(newPosition, newPosition)
      }, 0)
    }
  }

  return (
    <div>
      <FormControl variant="standard" margin="normal" sx={{ width: "100%" }} >
        <InputLabel
          sx={{
            position: "absolute",
            right: 0,
            left: "initial",
            top: 13,
            display: { xs: "none", sm: "block" }
          }}
        >
          Quantité à imprimer
        </InputLabel>
        <TextField
          inputRef={textareaRef}
          InputProps={{
            inputProps: { minLength: 0, inputMode: "none", readOnly: true },
            inputMode: "none",
            readOnly: true
          }}
          variant="standard"
          className={clsx(classes.calculatorInput)}
          value={inputValue}
          onChange={handleInputChange}
          placeholder="01"
        />
      </FormControl>
      <div className={classes.calculator}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, "b", 0, "p"].map(function render(elem, index) {
          return (
            <div
              key={index}
              className={clsx(classes.calculatorButton, { disabled: elem === "p" && printDisabled })}
              onClick={function onClick() {
                handleClickButton(elem)
              }}
            >
              {elem === "p" && (
                <PrintIcon sx={{ fontSize: 30 }} classes={{ root: classes.rootIcon }} />
              )}
              {elem === "b" && (
                <BackspaceIcon sx={{ fontSize: 25 }} classes={{ root: classes.rootIcon }} />
              )}
              {elem !== "p" && elem !== "b" && elem}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default NumericKeypad